import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

export default function Platform({ platformData, className }) {
    const { platform } = platformData;
    const platformNameText = platform.replace('_', ' ');
    const wrapperClassNames = `platform ${className} ${platform.replace('_', '-')}`;
    const iconClassNames = `platform-icon ${platform} hint--top`;

    return (
        <li className={wrapperClassNames}>
            <i className={iconClassNames} aria-hidden="true" data-hint={platformNameText}/>
            <span className="text">{platformNameText}</span>
        </li>
    );
}

Platform.propTypes = {
    platformData: PropTypes.shape({
        platform: PropTypes.string
    }),
    className: PropTypes.string
};

Platform.defaultProps = {
    platformData: {
        platform: ''
    },
    className: ''
};
